import { updateAttachments } from '../utilities';
export const photoCaptureAttachmentReducer = (state, action) => {
    const updatedStore = updateAttachments(state, action.payload.photoCaptureAttachmentData.processedAttachmentInfoList);
    return Object.assign(Object.assign({}, updatedStore), { ocrInfo: {
            ocrText: '',
            errorMessage: ''
        }, isContextUpdated: false });
};
//# sourceMappingURL=photoCaptureAttachmentReducer.js.map